
import React from "react";

export default function Reaction({ result }) {
  return (
    <div className="reaction">
      {result && <span className="reaction-emoji">{result}</span>}
    </div>
  );
}